import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import ContactCTA from '../../../components/home/ContactCTA';

const heroImage = 'https://www.intravis.com/hs-fs/hubfs/Products/Bottles%20and%20Containers/intravis-bottles-container-inspection-product-1920x1280px.jpg?width=1920&height=1280&name=intravis-bottles-container-inspection-product-1920x1280px.jpg';
const productImage = 'https://www.intravis.com/hs-fs/hubfs/Products/Bottles%20and%20Containers/intravis-bottles-containers-inspection-production-hall-1920x900px.jpg?width=1920&height=900&name=intravis-bottles-containers-inspection-production-hall-1920x900px.jpg';
const spotWatcherBasicImage = 'https://www.intravis.com/hubfs/Products/Bottles%20and%20Containers/SpotWatcher%20Preconfigured/intravis-bottles-spotwatcher-preconfigured-M-1920x1280px.jpg';
const spotWatcherImage = 'https://www.intravis.com/hubfs/Products/Bottles%20and%20Containers/SpotWatcher/intravis-spotwatcher-slash-design-700x400px.jpg';
const spotWatcherPharmaImage = 'https://www.intravis.com/hubfs/Products/Bottles%20and%20Containers/SpotWatcher%20Pharma%20Container/intravis-bottles-spotwatcher-pharma-container-inspection-1920x1280px.jpg';

const BottlesContainersInspection = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, 100);
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }, []);

  return (
    <>
      <section
        className="relative text-white h-56 sm:h-72 md:h-96 mt-20 sm:mt-12"
        style={{
          backgroundImage: `linear-gradient(rgba(15, 23, 42, 0.45), rgba(15, 23, 42, 0.45)), url(${heroImage})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
        }}
      >
        <div className="absolute inset-0 bg-black/40 pointer-events-none" />
        <div className="container mx-auto px-4 h-full flex items-center">
          <div className="text-white">
            <h1 className="text-3xl md:text-4xl font-bold">Bottle &amp; Container Inspection</h1>
            <p className="mt-2 max-w-2xl">Comprehensive bottle and container inspection systems for defect-free packaging production.</p>
            <div className="mt-6">
              <Link to="/products/intravis" className="text-blue-200 hover:text-white font-medium">
                ← Back to Inspection Systems
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid gap-12 lg:grid-cols-2 items-center">
            <div>
              <h2 className="text-3xl font-bold mb-6">Inspection for bottles and containers</h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                Intravis Bottle &amp; Container Inspection systems are built for precise quality control of bottles, jars, and containers. Their vision systems detect holes, spots, color deviations, and geometric defects across the entire product surface.
              </p>
              <p className="text-gray-700 mb-4 leading-relaxed">
                These solutions are ideal for beverage, pharmaceutical, food and chemical packaging lines that demand fast inspection, reliable rejection, and full traceability.
              </p>
              <div className="grid gap-4 sm:grid-cols-2">
                <div className="bg-gray-50 p-6 rounded-xl shadow-sm">
                  <h3 className="text-xl font-semibold mb-3">What is inspected</h3>
                  <ul className="space-y-2 text-gray-700">
                    <li>Surface defects, spots and scratches</li>
                    <li>Mouth and base defects</li>
                    <li>Color and fill-level deviations</li>
                    <li>Label and decoration quality</li>
                  </ul>
                </div>
                <div className="bg-gray-50 p-6 rounded-xl shadow-sm">
                  <h3 className="text-xl font-semibold mb-3">Why it matters</h3>
                  <ul className="space-y-2 text-gray-700">
                    <li>Prevent faulty packaging from reaching customers</li>
                    <li>Maintain brand quality through consistent inspection</li>
                    <li>Reduce customer complaints and recalls</li>
                    <li>Enable fast line speeds with reliable automation</li>
                  </ul>
                </div>
              </div>
            </div>
            <div>
              <img src={productImage} alt="Intravis Bottle and Container Inspection" className="w-full h-full rounded-3xl object-cover shadow-2xl" />
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold mb-8">Highlighted Intravis systems</h2>
          <div className="grid gap-6 md:grid-cols-3">
            <div className="bg-white p-6 rounded-3xl shadow-md">
              <img src={spotWatcherBasicImage} alt="SpotWatcher Basic" className="w-full h-44 object-cover rounded-3xl mb-5" />
              <h3 className="text-xl font-semibold mb-3">SpotWatcher Basic</h3>
              <p className="text-gray-600 mb-4">Compact and space-saving inspection for basic bottle quality checks.</p>
              <div className="text-sm text-gray-600 space-y-2">
                <p>Designed for quick deployment with standard bottle and container lines.</p>
                <p>Benefits: fast setup, stable performance, reliable surface and fill checks.</p>
              </div>
              <div className="mt-4">
                <Link to="/contact" className="inline-block bg-green-600 hover:bg-green-700 text-white font-medium py-2 px-4 rounded-md text-sm">
                  Know More
                </Link>
              </div>
            </div>
            <div className="bg-white p-6 rounded-3xl shadow-md">
              <img src={spotWatcherImage} alt="SpotWatcher" className="w-full h-44 object-cover rounded-3xl mb-5" />
              <h3 className="text-xl font-semibold mb-3">SpotWatcher</h3>
              <p className="text-gray-600 mb-4">Modular inspection for bottles and containers with advanced surface and geometry evaluation.</p>
              <div className="text-sm text-gray-600 space-y-2">
                <p>Designed for flexible product changeovers and multi-criteria inspection.</p>
                <p>Benefits: modular design, automated changeover, broader inspection capability.</p>
              </div>
              <div className="mt-4">
                <Link to="/contact" className="inline-block bg-green-600 hover:bg-green-700 text-white font-medium py-2 px-4 rounded-md text-sm">
                  Know More
                </Link>
              </div>
            </div>
            <div className="bg-white p-6 rounded-3xl shadow-md">
              <img src={spotWatcherPharmaImage} alt="SpotWatcher Pharma" className="w-full h-44 object-cover rounded-3xl mb-5" />
              <h3 className="text-xl font-semibold mb-3">SpotWatcher Pharma</h3>
              <p className="text-gray-600 mb-4">Pharmaceutical-grade inspection for strict hygiene and product integrity requirements.</p>
              <div className="text-sm text-gray-600 space-y-2">
                <p>Built for clean environments and traceable inspection of drug containers.</p>
                <p>Benefits: hygienic design, strict defect detection, documented quality assurance.</p>
              </div>
              <div className="mt-4">
                <Link to="/contact" className="inline-block bg-green-600 hover:bg-green-700 text-white font-medium py-2 px-4 rounded-md text-sm">
                  Know More
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <ContactCTA />
    </>
  );
};

export default BottlesContainersInspection;
